import React from "react";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { useLandingUrl } from "./useLandingUrl";
import { Destination } from "./types";
import { Styles, withStyles } from "./styles";

export interface TopDestinationsProps {
  destinations?: Destination[];
}

const BaseTopDestinations: React.FC<TopDestinationsProps & Styles> = ({
  classes,
  destinations
}) => {
  const getLandingUrl = useLandingUrl();
  return (
    <div className={classes.mainContainer}>
      <section className={classes.sectionContainer}>
        <Typography variant="h5" component="h2" align="center" className={classes.title}>
          Destinos populares
        </Typography>
        <ul className={classes.container}>
          {destinations!.map((destination, index) => (
            <li key={index} className={classes.containerItem}>
              <Link variant="body1" href={getLandingUrl(destination)} inline={true}>
                {destination.name}
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export const TopDestinations = withStyles(BaseTopDestinations);
